var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEiCustomToolPan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12V4.5C6 4.10218 6.15804 3.72064 6.43934 3.43934C6.72064 3.15804 7.10218 3 7.5 3C7.89782 3 8.27936 3.15804 8.56066 3.43934C8.84196 3.72064 9 4.10218 9 4.5M9 4.5V11M9 4.5V2.5C9 2.30302 9.0388 2.10796 9.11418 1.92597C9.18956 1.74399 9.30005 1.57863 9.43934 1.43934C9.57863 1.30005 9.74399 1.18956 9.92597 1.11418C10.108 1.0388 10.303 1 10.5 1C10.697 1 10.892 1.0388 11.074 1.11418C11.256 1.18956 11.4214 1.30005 11.5607 1.43934C11.6999 1.57863 11.8104 1.74399 11.8858 1.92597C11.9612 2.10796 12 2.30302 12 2.5V11M12 4.5C12 4.10218 12.158 3.72064 12.4393 3.43934C12.7206 3.15804 13.1022 3 13.5 3C13.8978 3 14.2794 3.15804 14.5607 3.43934C14.842 3.72064 15 4.10218 15 4.5V11",
    fill: "var(--primaryA2)",
    stroke: "var(--primaryA1)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 6.5C14.9999 6.10218 15.158 5.72064 15.4393 5.43934C15.7206 5.15804 16.1021 5 16.4999 5C16.8978 5 17.2793 5.15804 17.5606 5.43934C17.8419 5.72064 17.9999 6.10218 17.9999 6.5V15C17.9999 16.5913 17.3678 18.1174 16.2426 19.2426C15.1174 20.3679 13.5912 21 11.9999 21H9.99994H10.2079C9.21428 21.0002 8.23613 20.7535 7.36132 20.2823C6.48652 19.811 5.74245 19.1299 5.19594 18.3L4.99994 18C4.68794 17.5213 3.59261 15.612 1.71394 12.272C1.52239 11.9315 1.47122 11.5298 1.57132 11.1522C1.67142 10.7745 1.91489 10.4509 2.24994 10.25C2.60697 10.0364 3.02505 9.94793 3.438 9.99864C3.85096 10.0494 4.23521 10.2363 4.52994 10.53L5.99994 12",
    stroke: "var(--primaryA1)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEiCustomToolPan);
export default __webpack_public_path__ + "static/media/EICustomToolPan.fb9bb31153ef8ec022053437a4877768.svg";
export { ForwardRef as ReactComponent };